module.exports = __webpack_public_path__ + "img/no-frills.a7fb4c3d.svg";